import React, { useContext } from "react";
import DesktopNavigation from "./navigation/desktopNavigation";
import MobileNavigation from "./navigation/mobileNavigation";
import { Global } from "../context/globalContextProvider";
import useClientSide from "../hooks/useClientSide";

const Header = ({ isDonationHeader, campaignToDonationLink, cosmosCampaignId }) => {
  const isClientSide = useClientSide();
  const globalContext = useContext(Global);

  if (!isClientSide) {
    return null;
  }

  const urlParams = globalContext?.urlParams ?? "";

  return (
    <>
      <DesktopNavigation
        campaignToDonationLink={campaignToDonationLink}
        cosmosCampaignId={cosmosCampaignId}
        urlParams={urlParams}
        isDonationHeader={isDonationHeader}
      />
      <MobileNavigation
        campaignToDonationLink={campaignToDonationLink}
        cosmosCampaignId={cosmosCampaignId}
        urlParams={urlParams}
        isDonationHeader={isDonationHeader}
      />
    </>
  );
};

export default Header;
